import {JsonUtil} from "../lib/JsonUtil";

export const System = {

    getSystemColumns() {

        const columns = [
            { field: 'version',   headerName: 'Version',            type: 'number', width: 100, sortable: true },
            { field: 'insert_ts', headerName: 'Erstellt am',        type: 'string', width: 200, sortable: true },
            { field: 'insert_by', headerName: 'Erstellt von',       type: 'string', width: 150, sortable: true },
            { field: 'update_ts', headerName: 'Aktualisiert am',    type: 'string', width: 200, sortable: true },
            { field: 'update_by', headerName: 'Aktualisiert von',   type: 'string', width: 150, sortable: true },
        ];


        return columns;
    },

    getInsertSystemColumns() {

        const columns = [
            { field: 'insert_ts', headerName: 'Hochgeladen am',     type: 'string', width: 200, sortable: true },
            { field: 'insert_by', headerName: 'Hochgeladen von',    type: 'string', width: 160, sortable: true },
        ];

        return columns;
    },

    initializeFormErrors(formValues) {
        return Object.keys(formValues).reduce((acc, key) => {
            acc[key] = null;
            return acc;
        }, {});
    },

    removeAllWhitespace(value) {
        return value.replace(/\s+/g, "");
    },

    mapDbToValue(dbValue) {
        return (dbValue === null ? "" : dbValue);
    },

    mapDbToCode(dbValue) {
        return (dbValue === null ? -1 : dbValue);
    },

    mapDbToArray(dbValue) {
        return JsonUtil.convertJsonStringToArray(dbValue);
    },


    mapValueToDb(formValue) {
        return (formValue === undefined || formValue === "" ? null : formValue)
    },

    mapCodeToDb(formValue) {
        return (formValue === -1 ? null : formValue);
    },

    mapArrayToDb(formValue) {
        return JsonUtil.convertArrayToJsonStringOrNull(formValue);
    },

    mapValueToQuery(formValue) {
        return (formValue === undefined || formValue === "" ? null : formValue)
    },

    mapCodeToQuery(formValue) {
        return (formValue === -1 || formValue === "-1" ? null : formValue);
    },


};
